import { Box } from "@mui/material";
import { ReactNode } from "react";

interface ICardContent {
    children: ReactNode;
}

const CardContent = ({ children }: ICardContent) => {
    return (
        <Box
            height={"280px"}
            padding={"10px 20px"}
            sx={{ overflowY: "scroll" }}
        >
            {children}
        </Box>
    );
};

export default CardContent;
